import {ScoreModel} from '@app/core/models/score.model';
import {ScoreName} from '@app/core/models/enumerations/score-name.enum';
import {ScoreType} from '@app/core/models/enumerations/score-type.enum';

export const ScoreData: ScoreModel[] = [
  {
    id: ScoreType.SAT,
    label: ScoreName.ALL
  }, {
    id: ScoreType.Math,
    label: ScoreName.Math
  }, {
    id: ScoreType.EBRW,
    label: ScoreName.EBRW
  }
];
